import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ChangeEmail from '../views/ChangeEmail.vue'

import AdminMainLayout from '../views/admin/MainLayout.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import AdminConfigs from '../views/admin/Configs.vue'
import AdminLogs from '../views/admin/Logs.vue'
import AdminUsers from '../views/admin/Users.vue'
import AdminRobots from '../views/admin/Robots.vue'
import AdminChips from '../views/admin/Chips.vue'
import AdminSchedules from '../views/admin/Schedules.vue'
import AdminFirmwares from '../views/admin/Firmwares.vue'
import AdminOnline from '../views/admin/Online.vue'

// 用户端页面
import UserDashboard from '../views/robot/RobotDashboard.vue'
import RobotControl from '../views/robot/RobotControl.vue'
import RobotShare from '../views/robot/RobotShare.vue'
import UserDetails from '../views/robot/UserDetails.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'UserDashboard',
    component: UserDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/change-email',
    name: 'ChangeEmail',
    component: ChangeEmail,
    meta: { requiresAuth: true }
  },
  {    
    path: '/robot/:id',
    name: 'RobotControl',
    component: RobotControl,
    meta: { requiresAuth: true }
  },
  {    
    path: '/robot/share/:id',
    name: 'RobotShare',
    component: RobotShare,
    meta: { requiresAuth: true }
  },
  {    
    path: '/user/details',
    name: 'UserDetails',
    component: UserDetails,
    meta: { requiresAuth: true }
  },
  // 管理员端路由
  {
    path: '/admin',
    component: AdminMainLayout,
    meta: { requiresAuth: true, userType: 'admin' },
    children: [
      {
        path: '',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: {
          menu: {
            title: '仪表盘',
            icon: 'el-icon-s-home',
            isDefault: true,
            order: 1
          }
        }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsers,
        meta: {
          menu: {
            title: '用户管理',
            icon: 'el-icon-user',
            order: 2
          }
        }
      },
      {
        path: 'robots',
        name: 'AdminRobots',
        component: AdminRobots,
        meta: {
          menu: {
            title: '机器人管理',
            icon: 'el-icon-cpu',
            order: 3
          }
        }
      },
      {
        path: 'chips',
        name: 'AdminChips',
        component: AdminChips,
        meta: {
          menu: {
            title: '芯片管理',
            icon: 'el-icon-postcard',
            order: 4
          }
        }
      },
      {
        path: 'schedules',
        name: 'AdminSchedules',
        component: AdminSchedules,
        meta: {
          menu: {
            title: '定时任务',
            icon: 'el-icon-time',
            order: 5
          }
        }
      },
      {
        path: 'firmwares',
        name: 'AdminFirmwares',
        component: AdminFirmwares,
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          menu: {
            title: '版本管理',
            icon: 'el-icon-upload',
            order: 6
          }
        }
      },
      {
        path: 'configs',
        name: 'AdminConfigs',
        component: AdminConfigs,
        meta: {
          menu: {
            title: '配置管理',
            icon: 'el-icon-s-tools',
            order: 7
          }
        }
      },
      {
        path: 'online',
        name: 'AdminOnline',
        component: AdminOnline,
        meta: {
          menu: {
            title: '在线管理',
            icon: 'el-icon-monitor',
            order: 8
          }
        }
      },
      {
        path: 'logs',
        name: 'AdminLogs',
        component: AdminLogs,
        meta: {
          menu: {
            title: '日志管理',
            icon: 'el-icon-document',
            order: 9
          }
        }
      },
      {
        path: 'main',
        name: 'AdminMain',
        component: AdminMainLayout
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决路由重复导航问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router